module.exports = __webpack_public_path__ + "10521512d24bfcacb040f9d9830ba69b.svg";